define('GlobalViews.ShowingCurrent.View.Extension', [
  'GlobalViews.ShowingCurrent.View',
  'underscore',
  'Utils'
], function (View, _, Utils) {
  'use strict';

  return _.extend(View.prototype, {
    getContext: _.wrap(View.prototype.getContext, function (fn) {
      var context = fn.apply(this, _.toArray(arguments).slice(1));

      if (this.options.flag) {
        var options = Utils.parseUrlOptions(location.href);
        var current_page = Backbone.history.getFragment().split('page=')[1] || 1;
        var lastItem = ((options && options.page) || current_page) * this.options.items_per_page;
      }

      return _.extend(context, {
        firstItem:
          (options && options.page) || current_page
            ? (((options && options.page) || current_page) - 1) * this.options.items_per_page + 1
            : context.firstItem,
        lastItem: lastItem > this.options.total_items ? this.options.total_items : lastItem
      });
    })
  });
});
